module.exports = __webpack_public_path__ + "img/icon-cart-plus.c4de894d.svg";